import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { openQuorumAlert, closeQuorumAlert, cleanupQuorumAlert } from "app/static/frontend/global-action-creators"
import { quorumAlertConnection } from "app/static/frontend/main-selectors"

import { Dialog } from "quorumdesign"
import { AlertModal } from "app/static/frontend/QuorumAlert/style"

class QuorumAlert extends React.Component {
    constructor() {
        super()
        this.fire = this.fire.bind(this)
        this.close = this.close.bind(this)
    }

    componentDidMount() {
        // Setup Imperative API for react-modal
        qual.fire = this.fire
        qual.close = this.close
        window.qual = qual
    }

    // TODO: Can I extract these yieldResult functions, into a different part of the class,
    // so we don't have to pass them through the store?
    fire(config) {
        return new Promise((resolve) => {
            const yieldResultAndClose = (result) => {
                this.close()
                resolve(result)
            }

            const yieldResult = (result) => {
                resolve(result)
            }

            // TODO: Call a transform function here to convert swalConfigs to qualConfigs
            this.props.openQuorumAlert(config, yieldResult, yieldResultAndClose)
        })
    }

    close() {
        this.props.closeQuorumAlert()
    }

    render() {
        const { config, isOpen, yieldResult, yieldResultAndClose } = this.props

        return (
            <AlertModal isOpen={isOpen} onAfterClose={this.props.cleanupQuorumAlert}>
                <Dialog yieldResultAndClose={yieldResultAndClose} yieldResult={yieldResult} {...config}>
                    {config.children}
                </Dialog>
            </AlertModal>
        )
    }
}

export const qual = {
    fire: null,
    close: null,
}

QuorumAlert.defaultProps = {}

QuorumAlert.propTypes = {
    cleanupQuorumAlert: PropTypes.func,
    closeQuorumAlert: PropTypes.func,
    config: PropTypes.shape({
        actions: PropTypes.objectOf(
            PropTypes.oneOfType([
                PropTypes.bool,
                PropTypes.string,
                PropTypes.shape({
                    text: PropTypes.string,
                    // eslint-disable-next-line react/forbid-prop-types
                    value: PropTypes.any,
                    type: PropTypes.string,
                    closeAlert: PropTypes.bool,
                }),
            ])
        ),
        children: PropTypes.element,
        closeOnClickOutside: PropTypes.bool,
        content: PropTypes.shape({
            element: PropTypes.string,
            attributes: PropTypes.shape({
                dataCy: PropTypes.string,
                id: PropTypes.string,
                label: PropTypes.string,
                placeholder: PropTypes.string,
                value: PropTypes.string,
            }),
        }),
        icon: PropTypes.string,
        iconColor: PropTypes.string,
        iconFamily: PropTypes.string,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }),
    isOpen: PropTypes.bool,
    openQuorumAlert: PropTypes.func,
    yieldResult: PropTypes.func,
    yieldResultAndClose: PropTypes.func,
}

export default connect(quorumAlertConnection, { openQuorumAlert, closeQuorumAlert, cleanupQuorumAlert })(QuorumAlert)
